import React, { useEffect, useState } from "react";

type ToastProps = {
  message: string;
  type?: "success" | "error";
  onClose?: () => void;
  duration?: number; // ms
};

const Toast: React.FC<ToastProps> = ({
  message,
  type = "success",
  onClose,
  duration = 3000,
}) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Start fade in after mount
    const showTimer = setTimeout(() => setVisible(true), 20);
    // Start fade out before unmount (fade duration: 300ms)
    const hideTimer = setTimeout(() => setVisible(false), duration - 300);
    // Remove from DOM
    const closeTimer = setTimeout(() => onClose && onClose(), duration);

    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
      clearTimeout(closeTimer);
    };
  }, [onClose, duration]);

  return (
    <div
      className={`
        fixed left-1/2 top-28 transform -translate-x-1/2 z-50
        px-6 py-3 rounded-2xl shadow-lg text-white font-semibold
        transition-opacity duration-300
        ${type === "success" ? "bg-green-500" : "bg-red-500"}
        ${visible ? "opacity-100" : "opacity-0"}
      `}
      style={{ pointerEvents: "auto" }}
    >
      {message}
    </div>
  );
};

export default Toast;